module.exports = __webpack_public_path__ + "img/google-slides-2.d15e6a0b.webp";